import { useState, useRef, useEffect } from "react";
import { Box, Typography } from "@material-ui/core";
import { ErrorBoundary } from "@sentry/react";
import Player from "../../Player/player.component.jsx";
import MediaError from "../../Utilities/ErrorFalbackComponents/MediaError.jsx";

const VersionVideoPlayer = ({
  currentVersion,
  versions,
  setCurrentVersion,
  player,
}) => {
  const [seekTime, setSeekTime] = useState(0);
  const [playerProgress, setPlayerProgress] = useState("00:00");
  const [playing, setPlaying] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const frameRate = 24;
  const playerContainer = useRef(null);

  const handlePlayPause = () => {
    setPlaying(!playing);
  };

  const seekFiveSecondsForward = () => {
    if (player && player.current) {
      player.current.currentTime = Math.min(
        player.current.duration,
        player.current.currentTime + 5
      );
    }
  };

  const seekFiveSecondsBack = () => {
    if (player && player.current) {
      player.current.currentTime = Math.min(
        player.current.duration,
        player.current.currentTime - 5
      );
    }
  };

  const seekForward = () => {
    if (player && player.current) {
      setPlaying(false);
      player.current.pause();
      player.current.currentTime = Math.min(
        player.current.duration,
        player.current.currentTime + 1 / frameRate
      );
    }
  };

  const seekBack = () => {
    if (player && player.current) {
      setPlaying(false);
      player.current.pause();
      player.current.currentTime = Math.min(
        player.current.duration,
        player.current.currentTime - 1 / frameRate
      );
    }
  };

  const handleFullScreen = () => {
    if (playerContainer.current) {
      if (!document.fullscreenElement) {
        playerContainer.current.requestFullscreen();
        setIsFullScreen(true);
      } else {
        document.exitFullscreen();
        setIsFullScreen(false);
      }
    }
  };

  const handleSeekKeyboardEvent = (event) => {
    switch (true) {
      case event.key === " ":
        handlePlayPause();
        break;
      case !event.shiftKey && !event.ctrlKey && event.key === "ArrowRight":
        seekFiveSecondsForward();
        break;
      case !event.shiftKey && !event.ctrlKey && event.key === "ArrowLeft":
        seekFiveSecondsBack();
        break;
      case event.keyCode === 188 || event.key === ",":
        seekBack();
        break;
      case event.keyCode === 190 || event.key === ".":
        seekForward();
        break;
      case event.key === "f":
        handleFullScreen();
        break;
      default:
        break;
    }
  };

  const playNextVersion = () => {
    const nextVersionIndex =
      versions.findIndex((version) => version.id === currentVersion.id) + 1;
    if (nextVersionIndex < versions.length) {
      console.log(versions[nextVersionIndex]);
      setCurrentVersion(versions[nextVersionIndex]);
    } else {
      setPlaying(false);
    }
  };

  useEffect(() => {
    if (player && player.current && currentVersion) {
      if (!playing && currentVersion.id !== versions[0].id) {
        handlePlayPause();
      }
    }
  }, [currentVersion]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "calc(100% - 216px)",
        marginBottom: "12px",
      }}
    >
      <ErrorBoundary
        fallback={({ error, componentStack, resetError }) => (
          <MediaError
            error={error}
            resetError={resetError}
            componentStack={componentStack}
            file={currentVersion.trackable_file_url}
          />
        )}
        beforeCapture={(scope) => {
          scope.setTag("location", "vedio viewer");
          scope.setTag("version", currentVersion.id);
        }}
      >
        <Player
          seekTime={seekTime}
          setSeekTime={setSeekTime}
          setPlayerProgress={setPlayerProgress}
          setScreenshot={() => { }}
          screenshot={null}
          canvasModal={false}
          comments={[]}
          setCanvasModal={() => { }}
          data={currentVersion.trackable_file_url}
          player={player}
          playing={playing}
          setPlaying={setPlaying}
          handlePlayPause={handlePlayPause}
          seekBack={seekBack}
          seekForward={seekForward}
          selectedVersion={currentVersion.id}
          playerContainer={playerContainer}
          handleFullScreen={handleFullScreen}
          isFullScreen={isFullScreen}
          handleSeekKeyboardEvent={handleSeekKeyboardEvent}
          // scrollToComment={scrollToComment}
          forExternalReviewer={true}
          playNextVersion={playNextVersion}
        />
      </ErrorBoundary>
    </Box>
  );
};

export default VersionVideoPlayer;
